import { trackPromise } from 'react-promise-tracker';

const validate = (r) => {
  if (r.data?.errorMsg && r.data?.errorMsg !== '0000') throw r.data;
};

export default function createMallOperationAPI(axios) {
  return {
    getMallList: async () => {
      try {
        const result = await trackPromise(axios.get('/api/Mall/List'));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    postNewMall: async (data) => {
      try {
        const result = await trackPromise(axios.post('/api/Mall/New', JSON.stringify(data), {
          headers: { accept: 'application/octet-stream', 'content-type': 'application/json' },
        }));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    // market.toJSON()
    postUpdateMall: async (data) => {
      try {
        const result = await trackPromise(axios.post('/api/Mall/Update', data));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    postDeleteMall: async (id) => {
      try {
        const data = {
          id,
        };
        const result = await trackPromise(axios.post('/api/Mall/Delete', data));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          id,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },

    deleteAdMedia: async (id) => {
      try {
        const data = { id };
        const result = await trackPromise(axios.post(
          'api/AdContent/Delete',
          data,
        ));
        return result.data;
      } catch (error) {
        const errorMessage = {
          id,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    postMallMedia: async (id, file) => {
      try {
        const newFile = new File([file], file.name, { type: file.type.slice(0, 50) });
        const formData = new FormData();
        formData.append('File', newFile);
        const result = await trackPromise(axios.post(
          'api/MallContent/Upload',
          formData,
          {
            params: { Id: id },
          },
        ));
        return result.data;
      } catch (error) {
        const errorMessage = {
          id,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    deleteMallAsset: async (id) => {
      try {
        const data = { id };
        const result = await trackPromise(axios.post(
          'api/MallContent/Delete',
          data,
        ));
        return result.data;
      } catch (error) {
        const errorMessage = {
          id,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    getMallAssets: async (id) => {
      try {
        const result = await trackPromise(axios.get(
          'api/MallContent/List',
          {
            params: { Id: id },
          },
        ));
        return result.data;
      } catch (error) {
        const errorMessage = {
          id,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
  };
}
